import React, { useState } from 'react'

import ItemInvoiceComponent from './ItemInvoiceComponent'
import ModalComponent from './ModalComponent'

export const InvoiceDelayed = ({ item, index }) => {
  const [isShowModal, setIsShowModal] = useState(false)

  return (
    <>
      <ItemInvoiceComponent
        index={index}
        item={item}
        buttonLabel="Declarar renda"
        setIsShowModal={setIsShowModal}
        status="atrasada"
      />

      {isShowModal && <ModalComponent item={item} setIsShowModal={setIsShowModal} />}
    </>
  )
}
